import { configureStore } from '@reduxjs/toolkit'

import { withReduxConfigs } from 'utils'
import searchApi from '~header/services/search'
import userApi from '~header/services/user'

export const store = configureStore(
  withReduxConfigs({
    reducer: {
      searchApi: searchApi.reducer,
      userApi: userApi.reducer
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false })
        .concat(searchApi.middleware)
        .concat(userApi.middleware)
  })
)
